/**
 * Shared SSE helpers — EventSource wrapper + 测试注入点。
 * 之前抽在 SSEEventList 组件里，SSEEventList 随 IA 重构被删除，故挪到这里。
 */

export interface EventSourceLike {
  onmessage: ((ev: { data: string }) => void) | null;
  onerror: ((ev: unknown) => void) | null;
  close(): void;
}

export function defaultEventSourceFactory(url: string): EventSourceLike {
  const es = new EventSource(url, { withCredentials: true });
  return {
    get onmessage() {
      return es.onmessage as ((ev: { data: string }) => void) | null;
    },
    set onmessage(h) {
      es.onmessage = h as typeof es.onmessage;
    },
    get onerror() {
      return es.onerror as ((ev: unknown) => void) | null;
    },
    set onerror(h) {
      es.onerror = h as typeof es.onerror;
    },
    close: () => es.close(),
  };
}
